import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetTicketTypes, actionDeleteTicketType, actionUpdateMenu, actionSaveRestaurant } from "../../actions/RestaurantActions"
import { LOGIN_ROUTE, TICKET_TYPE_ADD_ROUTE, TICKET_TYPE_EDIT_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Card,
  CardHeader,
  CardMedia,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle, 
  Paper,
  Typography, 
  Fab,
  FormControl,
  Toolbar,
  Tooltip,
  TextField,
  Input,
  InputAdornment,
  InputLabel
} from "@material-ui/core"

import ColorIcon from '@material-ui/icons/FiberManualRecord';
import SuggestIcon from '@material-ui/icons/StarRate';
import Util, { ERROR, INFO } from '../../common/Util'
import Roles from "../../config/RolesConstants"
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import ColorField from '../../components/ColorField/ColorField'



class MenuStyleConfig extends React.PureComponent{
  constructor(props){
    super(props)
    console.log("menuConfig",props.menuConfig)
    let config = props.menuConfig||{}
    this.state = {
      headerBackgroundColor:config.headerBackgroundColor,
      bodyBackgroundColor:config.bodyBackgroundColor,
      menuSuggestTitle:config.suggest&&config.suggest.title,
      menuSuggestBackgroundColor:config.suggest&&config.suggest.backgroundColor,
      menuSuggestItem:config.suggest&&config.suggest.menu||{},
      menuCategoryColor:config.menu&&config.menu.categoryColor,
      menuPriceColor:config.menu&&config.menu.priceColor,
      menuTitleColor:config.menu&&config.menu.titleColor,
      menuDetailColor:config.menu&&config.menu.detailColor
    }
    console.log("props.menuConfig",props.menuConfig)

    this.onApply = this.onApply.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeMenuSuggestItem = this.onChangeMenuSuggestItem.bind(this)
    
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.menuConfig){
      let config = nextProps.menuConfig
      this.setState({
        headerBackgroundColor:config.headerBackgroundColor,
        bodyBackgroundColor:config.bodyBackgroundColor,
        menuSuggestTitle:config.suggest&&config.suggest.title,
        menuSuggestBackgroundColor:config.suggest&&config.suggest.backgroundColor,
        menuSuggestItem:config.suggest&&config.suggest.menu||{},
        menuCategoryColor:config.menu&&config.menu.categoryColor,
        menuPriceColor:config.menu&&config.menu.priceColor,
        menuTitleColor:config.menu&&config.menu.titleColor,
        menuDetailColor:config.menu&&config.menu.detailColor
      })
    }
    console.log("nextProps.menuConfig",nextProps.menuConfig)
  }


  onApply(){
    let menuOptions =  {
      headerBackgroundColor:this.state.headerBackgroundColor,
      bodyBackgroundColor:this.state.bodyBackgroundColor,
      suggest:{
        title:this.state.menuSuggestTitle,
        backgroundColor:this.state.menuSuggestBackgroundColor,
        menu:this.state.menuSuggestItem
      },
      menu:{
        categoryColor:this.state.menuCategoryColor,
        priceColor:this.state.menuPriceColor,
        titleColor:this.state.menuTitleColor,
        detailColor:this.state.menuDetailColor
      }
    }
    console.log("MENU OPTIONS TO APPLY", menuOptions, this.state)
    this.props.onApply(menuOptions)
  }

  onChange(evt, field){
    let newState = {...this.state}
    newState[field] = evt.target.value 
    this.setState(newState)
  }

  onChangeMenuSuggestItem(evt, field){
    let menuSuggestItem = {...this.state.menuSuggestItem}
    menuSuggestItem[field] = evt.target.value 
    this.setState({menuSuggestItem:menuSuggestItem})
  }

  render(){
    const {open, preview} = this.props
    return (
        <Dialog open={open} fullScreen>
          <DialogTitle>Opciones de Menú Digital</DialogTitle>
          <Toolbar style={{justifyContent:"center"}}>
            <Box style={{width:"70%"}}>
              <Box style={{display:"flex", justifyContent:"space-between", margin:6}}>
                <Box>
                  <InputLabel shrink style={{fontWeight:"bold"}}>General</InputLabel>
                  <Box style={{display:"flex", justifyContent:"space-between"}}>
                    <TextField  
                              value={this.state.headerBackgroundColor} style={{width:80, marginLeft:6}} 
                              inputProps={{type:"color"}}
                              InputProps={{startAdornment:<InputAdornment position="start">Cabecera</InputAdornment>}}
                              onChange={(evt)=>{this.onChange(evt,"headerBackgroundColor")}}/>
                    <TextField  
                              value={this.state.bodyBackgroundColor} style={{width:61, marginLeft:8}} 
                              inputProps={{type:"color"}}
                              InputProps={{startAdornment:<InputAdornment position="start">Fondo</InputAdornment>}}
                              onChange={(evt)=>{this.onChange(evt,"bodyBackgroundColor")}}/>
                  </Box>
                </Box>
                <Box>
                  <InputLabel shrink style={{fontWeight:"bold"}}>Sugerencias</InputLabel>
                  <Box style={{display:"flex", justifyContent:"space-between"}}>
                    <TextField value={this.state.menuSuggestTitle} 
                              style={{width:"40%", marginLeft:8}} 
                              InputProps={{startAdornment:<InputAdornment position="start">Título</InputAdornment>}}
                              onChange={(evt)=>{this.onChange(evt,"menuSuggestTitle")}}/>
                    <TextField  
                              value={this.state.menuSuggestBackgroundColor} style={{width:61, marginLeft:8}} 
                              inputProps={{type:"color"}}
                              InputProps={{startAdornment:<InputAdornment position="start">Fondo</InputAdornment>}}
                              onChange={(evt)=>{this.onChange(evt,"menuSuggestBackgroundColor")}}/>
                  </Box>
                </Box>
              </Box>
              <InputLabel shrink style={{fontWeight:"bold", margin:6}}>Items Sugeridos</InputLabel>
              <Box style={{display:"flex", justifyContent:"space-between", margin:6}}>
                <TextField  
                            value={this.state.menuSuggestItem.backgroundColor} style={{width:61, marginLeft:8}} 
                            inputProps={{type:"color"}}
                            InputProps={{startAdornment:<InputAdornment position="start">Fondo</InputAdornment>}}
                            onChange={(evt)=>{this.onChangeMenuSuggestItem(evt,"backgroundColor")}}/>
                <TextField  
                          value={this.state.menuSuggestItem.titleColor} style={{width:70, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Nombre</InputAdornment>}}
                          onChange={(evt)=>{this.onChangeMenuSuggestItem(evt,"titleColor")}}/>
                <TextField  
                          value={this.state.menuSuggestItem.detailColor} style={{width:92, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Descripción</InputAdornment>}}
                          onChange={(evt)=>{this.onChangeMenuSuggestItem(evt,"detailColor")}}/>
                <TextField  
                          value={this.state.menuSuggestItem.priceColor} style={{width:60, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Precio</InputAdornment>}}
                          onChange={(evt)=>{this.onChangeMenuSuggestItem(evt,"priceColor")}}/>
              </Box>  
              <InputLabel shrink style={{fontWeight:"bold", margin:6}}>Menú</InputLabel>
              <Box style={{display:"flex", justifyContent:"space-between", margin:6}}>
                <TextField  
                          value={this.state.menuCategoryColor} style={{width:81, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Categoría</InputAdornment>}}
                          onChange={(evt)=>{this.onChange(evt,"menuCategoryColor")}}/>
                <TextField  
                          value={this.state.menuTitleColor} style={{width:70, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Nombre</InputAdornment>}}
                          onChange={(evt)=>{this.onChange(evt,"menuTitleColor")}}/>
                <TextField  
                          value={this.state.menuDetailColor} style={{width:92, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Descripción</InputAdornment>}}
                          onChange={(evt)=>{this.onChange(evt,"menuDetailColor")}}/>
                <TextField  
                          value={this.state.menuPriceColor} style={{width:60, marginLeft:8}} 
                          inputProps={{type:"color"}}
                          InputProps={{startAdornment:<InputAdornment position="start">Precio</InputAdornment>}}
                          onChange={(evt)=>{this.onChange(evt,"menuPriceColor")}}/>
              </Box>  
            </Box>
          </Toolbar>
          <DialogContent style={{width:"100%"}}>
            <Card>
              <CardMedia height={380}  width="100%" component="iframe" src={preview}/>
            </Card>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <Button variant="contained" color="secondary" onClick={this.props.onClose}>Cerrar</Button>
            </Tooltip>
            <Tooltip title="Aplicar cambios">
              <Button variant="contained" color="primary" onClick={this.onApply}>Aplicar</Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
    )
  }
}

export default MenuStyleConfig
  





// WEBPACK FOOTER //
// ./src/screens/restaurants/MenuStyleConfig.js